// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Sede',
  all_one: 'Tutte le {{count}} sedi',
  all_other: 'Tutte le {{count}} sedi',
};
